import { ThemePreset } from '@kanbu/schema/enums';

export const THEME_PRESETS = {
  light: {
    preset: ThemePreset.Light,
    primary: '#e4e4e7',
    primaryFg: '#27272a',
  },
  dark: {
    preset: ThemePreset.Dark,
    primary: '#18181B',
    primaryFg: '#f4f4f5',
  },
} as const;

// TODO these should be localized
export const AgentDefaults = {
  name: 'AI Honza',
  defaultThemePreset: ThemePreset.Light,
  defaultTheme: THEME_PRESETS.light,
} as const;

export const DEFAULT_DOCUMENT_WEIGHT = 0.5;
